export default __webpack_public_path__ + "static/media/a037-student-t3-5.a44fc21c.svg";